import React from "react";
import { Link } from "react-router-dom";
import ReUse from "../../services/helpers/reUse";
import CustomImage from "../../Components/ReUse/Components/Image";

const Recipe = (propsData) => {
  const {
    id,
    slug,
    title,
    short_description,
    views,
    creation_date,
    thumbnail,
    coverimageurl,
  } = propsData ?? {};
  return (
    <>
      <div className="col-md-3">
        <Link to={`/recipes-detail/${slug}`} state={slug}>
          <div className="recipe-all">
            <div className="recipe-img">
              <figure>
                {/* <CustomImage thumbnail={coverimageurl} /> */}
                <img src={coverimageurl}/>
              </figure>
            </div>
            <div className="recipe-para">
              <h4>{title && title}</h4>
              <div className="recipe-flex">
                <p>{short_description && short_description}</p>
                <div className="for-views">
                  <h5>{views && views} Views </h5>
                  <h5>{ReUse.dateFormat({ date: creation_date })} </h5>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default Recipe;
